import cogoToast from 'cogo-toast';
import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { adminAPIURL, customHeaders } from '../../../../../../Containers/Config/index.js';
import apiCall from '../../../../apiCall.js';

import { UPLOAD_CANCELATION_FILE, UPLOAD_CANCELATION_FILE_SUCCESS, UPLOAD_CANCELATION_FILE_ERROR } from './../../../../actionType.js';

function* uploadCancelationFile({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/upload-files`,
      method: 'POST',
      data: payload.data,
      isFormData: true,
      headers: {
        ...filteredHeaders,
      },
    });

    if (response.status === 200) {
      cogoToast.success('File uploaded successfully');
      yield put({
        type: UPLOAD_CANCELATION_FILE_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(`${response?.response?.data?.message}`);
      yield put({ type: UPLOAD_CANCELATION_FILE_ERROR, payload: response?.data?.message });
    }
  } catch (error) {
    yield put({ type: UPLOAD_CANCELATION_FILE_ERROR, payload: error });
  }
}

export function* watchuploadCancelationFile() {
  yield takeEvery(UPLOAD_CANCELATION_FILE, uploadCancelationFile);
}

function* uploadCancelationFileSaga() {
  yield all([fork(watchuploadCancelationFile)]);
}

export default uploadCancelationFileSaga;
